import logoIcon from '../../assets/logo-icon.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  iconOnly?: boolean;
}

export function Logo({ size = 'md', className = '', iconOnly = false }: LogoProps) {
  const iconSizes = {
    sm: 'h-7',
    md: 'h-9',
    lg: 'h-14',
  };

  const textSizes = {
    sm: 'text-xl',
    md: 'text-2xl',
    lg: 'text-4xl',
  };

  if (iconOnly) {
    return (
      <img
        src={logoIcon}
        alt="BT Vision"
        className={`${iconSizes[size]} w-auto ${className}`}
      />
    );
  }

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={logoIcon}
        alt=""
        className={`${iconSizes[size]} w-auto`}
      />
      <span className={`font-display font-bold gradient-text ${textSizes[size]}`}>
        BT Vision
      </span>
    </div>
  );
}
